function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-arrow"), React.createElement("g", {
  id: "icon-arrow-icon-arrow",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  id: "icon-arrow-Path",
  fill: "#000",
  fillRule: "nonzero",
  transform: "rotate(-180 50 50.5)",
  d: "M90.1114054 78L100 67.6685005 54.9410861 27.4488031 51.9570403 24.7617479 50.0005463 23 45.0499427 27.4568451 2.11259475 65.7827932 0 67.6685005 9.88859458 78 50 42.1859345z"
}))));